import { render, staticRenderFns } from "./DM_transactionHideDetail.vue?vue&type=template&id=35f37b4e&scoped=true&"
import script from "./DM_transactionHideDetail.vue?vue&type=script&lang=js&"
export * from "./DM_transactionHideDetail.vue?vue&type=script&lang=js&"
import style0 from "./DM_transactionHideDetail.vue?vue&type=style&index=0&id=35f37b4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f37b4e",
  null
  
)

export default component.exports